'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, Price } from '@petsmart-ui/sparky';
import { decodeEntityString } from '@libs/algolia';
import { useDecisions } from '@libs/common-next';
import type { Product } from '@libs/common-types';
import { PricePolicyDrawer } from '../PricePolicyDrawer';
import { getPriceDisplay } from '../product-details';
import { ResponsivePicture } from '../ResponsivePicture';
import { useMiniPdpDrawer } from './model/use-mini-pdp-drawer';
export function MiniPdpProductInfo(t0) {
  const $ = _c(33);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product.media) {
    t1 = product.media.find(_temp);
    $[0] = product.media;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const firstImage = t1;
  let t2;
  if ($[2] !== product.name) {
    t2 = decodeEntityString(product.name);
    $[2] = product.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const productName = t2;
  let t3;
  if ($[4] !== product) {
    t3 = getPriceDisplay(product);
    $[4] = product;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const priceDisplay = t3;
  const isDrawerOpen = useMiniPdpDrawer(_temp2);
  const close = useMiniPdpDrawer(_temp3);
  const productUrl = useMiniPdpDrawer(_temp4);
  const isAutoshipMiniPdpEnabled = useDecisions("as_mini_pdp");
  const linkUrl = isAutoshipMiniPdpEnabled ? productUrl : undefined;
  let t4;
  if ($[6] !== firstImage || $[7] !== productName) {
    t4 = firstImage && <ResponsivePicture src={firstImage.url} alt={productName} size={{
      width: 80,
      height: 80
    }} />;
    $[6] = firstImage;
    $[7] = productName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const image = t4;
  let t5;
  if ($[9] !== image || $[10] !== linkUrl) {
    t5 = image && <div className="mini-pdp-drawer__product-image">{linkUrl ? <a href={linkUrl} className="mini-pdp-drawer__product-link" tabIndex={-1} data-testid="mini-pdp-product-image-link">{image}</a> : image}</div>;
    $[9] = image;
    $[10] = linkUrl;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== linkUrl || $[13] !== productName) {
    t6 = linkUrl ? <a href={linkUrl} className="mini-pdp-drawer__product-link mini-pdp-drawer__product-link--title" data-testid="mini-pdp-product-name-link">{productName}</a> : productName;
    $[12] = linkUrl;
    $[13] = productName;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <Heading tagName="h3" className="sparky-u-theme-typography-body" data-testid="mini-pdp-product-name">{t6}</Heading>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== priceDisplay.values || $[18] !== priceDisplay.variant) {
    t8 = <Price values={priceDisplay.values} variant={priceDisplay.variant} size="xl" className="mini-pdp-drawer__product-price" data-testid="mini-pdp-product-price" />;
    $[17] = priceDisplay.values;
    $[18] = priceDisplay.variant;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== close || $[21] !== isDrawerOpen || $[22] !== priceDisplay.variant) {
    t9 = priceDisplay.variant === "disabled" && <PricePolicyDrawer showBackButton={true} forceClosed={!isDrawerOpen} onCloseAll={close} />;
    $[20] = close;
    $[21] = isDrawerOpen;
    $[22] = priceDisplay.variant;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <div className="mini-pdp-drawer__price">{t8}{t9}</div>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t7) {
    t11 = <div className="mini-pdp-drawer__product-content">{t7}{t10}</div>;
    $[27] = t10;
    $[28] = t7;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t5) {
    t12 = <div className="mini-pdp-drawer__product-info">{t5}{t11}</div>;
    $[30] = t11;
    $[31] = t5;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
}
function _temp4(state_1) {
  return state_1.productUrl;
}
function _temp3(state_0) {
  return state_0.close;
}
function _temp2(state) {
  return state.isOpen;
}
function _temp(item) {
  return item.type === "image";
}